import React, { useState } from "react";
import "./questiontabs.css";

function QuestionsTab({ ques, ans, state = false }) {
  const [showQuestion, setShowQuestion] = useState(state);
  const paragraphs = ans.split(".").filter(Boolean);

  return (
    <div className="question-container">
      <div
        className="question-layout"
        onClick={() => setShowQuestion((prev) => !prev)}
      >
        <div className="question-tab">
          <div className="icon-wrapper">
            <img
              src={`${
                !showQuestion
                  ? "/images/question-open-icon.png"
                  : "/images/question-close-icon.png"
              }`}
              alt="Question Icon"
              loading="lazy"
              decoding="async"
              className={`question-tab-icon ${
                showQuestion ? "question-tab-open" : "question-tab-closed"
              }`}
            />
          </div>
          <span className="question">{ques}</span>
        </div>
        <div className="icon-wrapper">
          <img
            src="/images/plus-icon.svg"
            loading="lazy"
            decoding="async"
            alt="Plus Icon"
            className={`plus-icon ${!showQuestion ? "visible" : "hidden"}`}
          />
          <img
            src="/images/cross.svg"
            alt="Cross Icon"
            loading="lazy"
            decoding="async"
            className={`cross-icon ${showQuestion ? "visible" : "hidden"}`}
          />
        </div>
      </div>

      <div className={`answer-tab ${showQuestion ? "open" : ""}`}>
        {paragraphs.map((paragraph, index) => (
          <span key={index}>{paragraph.trim()}.</span>
        ))}
      </div>
    </div>
  );
}

export default QuestionsTab;
